/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toRoomProps, toRoomRequest } from './translator/room'
import { toDoctorProps } from './translator/doctor'
import { toTalkerProps } from './translator/talker'
import { toQuery, toQueryProps } from './translator/query'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchRoom, PostRoom, FetchRoomGroups, FetchRoomDoctors, FetchRoomTalkers, GetRoom, DeleteRoom } from '@/infrastructure/network/Monitaro/requests/room'
import { IRoomProps } from '@/entities/Room'

export default class Room extends MonitaroGatewayBase {
  async FetchRoom(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchRoom(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.rooms.map((prop) => toRoomProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async PostRoom(params: IRoomProps) {
    const { room } = await this.apiClient.request(new PostRoom(toRoomRequest(params)))
    return toRoomProps(room)
  }

  async FetchRoomGroups(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchRoomGroups(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.rooms.map((prop) => toRoomProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async FetchRoomDoctors(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchRoomDoctors(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.doctors.map((prop) => toDoctorProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async FetchRoomTalkers(room: string, query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchRoomTalkers(room, toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.talkers.map((prop: any) => {
        // talker_typeからtypeを判定
        const type = prop.talker_type?.includes('User') ? 'user' : prop.talker_type?.includes('Doctor') ? 'doctor' : undefined
        return toTalkerProps(prop.talker || prop, type)
      }),
      query: toQueryProps(response.query)
    })
  }

  async GetRoom(id: string) {
    const { room } = await this.apiClient.request(new GetRoom(id))
    return toRoomProps(room)
  }

  async DeleteRoom(id: string) {
    const { room } = await this.apiClient.request(new DeleteRoom(id))
    return toRoomProps(room)
  }
}
